import React from 'react';
import { AlertBanner, Typography } from '@hpstellar/core/visId';

import useCartState from '../../../hooks/useCartState';
import GiftModal from './gift-modal';

import './free-gift-messages.less';

const getFreeGifts = cartView => {
    if (!cartView) {
        return [];
    }
    //check keys that start with x_addOnMsg_ID example x_addOnMsg_453192
    const freeGifts = Object.keys(cartView).filter(key => key.includes('x_addOnMsg_'));

    return freeGifts.map(key => ({
        rewardOptionId: key.split('_')[2],
        message: cartView[key],
    }));
};

export default ({}) => {
    const { cartInfo } = useCartState();
    const { cartView } = cartInfo || {};
    const { x_defaultMsg } = cartView || {};
    const freeGifts = getFreeGifts(cartView);
    if (freeGifts.length <= 0) {
        return null;
    }

    return (
        <div className="free-gift-container">
            {freeGifts.map(({ rewardOptionId, message }) => {
                return (
                    <AlertBanner className="message" key={rewardOptionId} theme="primary">
                        <div className="free-gift-row">
                            <Typography className="free-gift-message" weight={700}>
                                {x_defaultMsg}
                            </Typography>
                            <GiftModal message={message} rewardOptionId={rewardOptionId} />
                        </div>
                    </AlertBanner>
                );
            })}
        </div>
    );
};
